import { useState } from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import categoryService from '../../services/categoryService';
import Modal from '../../components/Common/Modal';
import Input from '../../components/Common/Input';
import Button from '../../components/Common/Button';

const CreateCategoryDialog = ({ isOpen, onClose, onSuccess }) => {
  const { get, isRtl } = useLocalization();
  const [formData, setFormData] = useState({
    nameEn: '',
    nameAr: '',
    descriptionEn: '',
    descriptionAr: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await categoryService.create(formData);
      setFormData({ nameEn: '', nameAr: '', descriptionEn: '', descriptionAr: '' });
      onSuccess();
    } catch (error) {
      console.error('Error creating category:', error);
      alert(isRtl ? 'حدث خطأ أثناء إنشاء التصنيف' : 'Error creating category');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={get('add_new_category')}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            {get('cancel')}
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {get('save')}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <Input
          label={isRtl ? 'الاسم (إنجليزي)' : 'Name (English)'}
          value={formData.nameEn}
          onChange={(e) => setFormData({ ...formData, nameEn: e.target.value })}
          required
        />
        <Input
          label={isRtl ? 'الاسم (عربي)' : 'Name (Arabic)'}
          value={formData.nameAr}
          onChange={(e) => setFormData({ ...formData, nameAr: e.target.value })}
          required
        />
        <div className="form-group">
          <label className="form-label">{isRtl ? 'الوصف (إنجليزي)' : 'Description (English)'}</label>
          <textarea
            className="form-textarea"
            value={formData.descriptionEn}
            onChange={(e) => setFormData({ ...formData, descriptionEn: e.target.value })}
            rows="3"
          />
        </div>
        <div className="form-group">
          <label className="form-label">{isRtl ? 'الوصف (عربي)' : 'Description (Arabic)'}</label>
          <textarea
            className="form-textarea"
            value={formData.descriptionAr}
            onChange={(e) => setFormData({ ...formData, descriptionAr: e.target.value })}
            rows="3"
          />
        </div>
      </form>
    </Modal>
  );
};

export default CreateCategoryDialog;
